<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName" label="充电站:" :label-width="60">
			<Select v-model="formInline.StationId" filterable placeholder="充电站" style="width: 120px;">
				<Option :value='0'>全部</Option>
				<Option :key="itemIndex" v-for="(item,itemIndex) in StationList" :value="item.StationId">{{item.StationName}}</Option>
			</Select>
		</FormItem>
		<FormItem prop="trackName">
			<Input style="width: 180px;" type="text" v-model="formInline.EquipmentModel" placeholder="设备型号">
			<span slot="prepend">设备型号</span>
			</Input>
		</FormItem>
		<FormItem prop="trackName">
			<Input style="width: 180px;" type="text" v-model="formInline.ConnectorNo" placeholder="充电枪编号">
			<span slot="prepend">充电枪编号</span>
			</Input>
		</FormItem>
		<!-- <FormItem label="开始时间" :label-width='70'>
			<DatePicker style="width: 110px;" :type="formInline.dateType" placeholder="Select date"
				v-model="formInline.TimeBegin"></DatePicker>
		</FormItem> -->
		<!-- <FormItem label="结束时间" :label-width='70'>
			<DatePicker style="width: 110px;" :type="formInline.dateType" placeholder="Select date"
				v-model="formInline.TimeEnd"></DatePicker>
		</FormItem> -->
		<FormItem label="选择时间" :label-width='70'>
			<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
				v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">查询</Button>
		</FormItem>
	</Form>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js'
	import {
		mapState,
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					StationId: 0,
					EquipmentModel: '',
					ConnectorNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 6), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 6), new Date()],
				},
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		},
	}
</script>

<style>
</style>
